import { render, staticRenderFns } from "./SettingManagementView.vue?vue&type=template&id=badff950&"
import script from "./SettingManagementView.vue?vue&type=script&lang=ts&"
export * from "./SettingManagementView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports